<div class="row">
  <div class="col-md-12 popin-container align-items justify-content-center">
    <div class="title text-center">
      <h1>Merci, vous allez être redirigé dans quelques secondes !</h1>
    </div>
    <div class="text-center">
      <a (click)="redirectOnClick()" style="cursor: pointer;">Si vous n'êtes pas redirigé automatiquement, cliquez ici !</a>
    </div>
  </div>
</div>
